class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    if (selector) {
      const parent = document.getElementById('shopify-section-cart-drawer');
      const rawProgress = parent && (parent.getAttribute('data-free-gift-progress') || parent.dataset.freeGiftProgress);

      if (rawProgress != null) {
        const progressValue = String(rawProgress).trim().replace(/%$/, '');
        const container = doc.querySelector(selector) || doc.body;
        const bar = container.querySelector('progress-bar'); // only one expected

        if (bar) {
          const existingStyle = bar.getAttribute('style') || '';
          let newStyle;

          if (/--progress:\s*[\d.]+%/i.test(existingStyle)) {
            newStyle = existingStyle.replace(/(--progress:\s*)[\d.]+%/i, `$1${progressValue}%`);
          } else {
            const trimmed = existingStyle.trim().replace(/\s*;?\s*$/, '');
            newStyle = trimmed ? `${trimmed}; --progress: ${progressValue}%;` : `--progress: ${progressValue}%;`;
          }

          bar.setAttribute('style', newStyle);
        }
      }
    }

    const node = doc.querySelector(selector);
    return node ? node.innerHTML : html;

    document.querySelector('cart-drawer').updateProgressBarInitial();
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
